import { createSelector } from '@ngrx/store';

import { referralsAdapter } from '@collections/referral/referral.reducer';

import { CollectionsState, getCollectionsState } from '../collections.reducer';

export const getReferralsState = createSelector(
  getCollectionsState,
  (state: CollectionsState) => !!state && state.referral,
);

export const {
  selectIds: getReferralIds,
  selectEntities: getReferralEntities,
} = referralsAdapter.getSelectors(getReferralsState);


export const getReferralById = createSelector(
  getReferralEntities,
  (entities, { id }) => !!id && !!entities ? entities[id] : null,
);
